module.exports = __webpack_public_path__ + "img/sup_vip_class_upgrading1.f86ac25e.jpg";